import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

const AgencyIntegrationsDisabledBanner = () => (
  <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
    <Box flexDirection="column">
      <Box alignItems="center" marginBottom="small">
        <FontAwesomeIcon color="orange" icon={faExclamationTriangle} />

        <Text fontSize="small" fontWeight="bold" marginLeft="small">Settings managed by your Brand Administrator</Text>
      </Box>

      <Text fontSize="small" color="bodyFontLightColor" lineHeight="1.3" marginTop="small">
        To ensure consistency across your network, your Corporate team manages these integration settings.
        Some options may be locked from editing.
        If you need to make changes to a locked setting, please contact your Head Office.
      </Text>
    </Box>
  </Box>
)

export default AgencyIntegrationsDisabledBanner
